import { Component, Vue } from 'vue-property-decorator';
// import { Mutation } from 'vuex-class';

@Component
export default class ListadosMixin extends Vue {

  protected listaEstatus: any[] = [
    {
      key: 'A', text: 'Activo',
    },
    {
      key: 'B', text: 'Inactivo',
    },
  ];

  // protected listaRoles: string[] = [
  //   'usuario',
  //   'admin'
  // ];

}
